import { render } from "./PolicyBeneficiary.vue?vue&type=template&id=516c9b67"
import script from "./PolicyBeneficiary.vue?vue&type=script&lang=js"
export * from "./PolicyBeneficiary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__